import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MotionDetectedIcon = (props: SvgProps) => (
  <Svg
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <Path
      fill="#F37887"
      d="M23.333.467a4.183 4.183 0 0 0-4.2 4.2c0 2.333 1.867 4.2 4.2 4.2 2.334 0 4.2-1.867 4.2-4.2 0-2.334-1.866-4.2-4.2-4.2Zm13.23 1.866a17.103 17.103 0 0 0 17.104 17.104v-3.104a14 14 0 0 1-14-14h-3.104Zm6.207 0c0 6.02 4.877 10.897 10.897 10.897v-3.127a7.767 7.767 0 0 1-7.77-7.77H42.77Zm6.23 0A4.666 4.666 0 0 0 53.667 7V2.333H49Zm-30.52 7.07c-.397 0-.793.07-1.167.187L4.667 13.533v12.134h4.2v-8.564l4.923-1.54-9.123 35.77h4.2l6.696-18.923L21 39.667v11.666h4.2V36.377l-5.81-10.594 1.703-6.696 2.52 4.246H35v-4.2h-8.447l-4.666-7.77c-.7-1.166-1.96-1.96-3.407-1.96Z"
    />
  </Svg>
);
export default MotionDetectedIcon;
